export class HighlightedItemUpdate {
  constructor(readonly itemId: number | null,
              readonly source: HighlightedItemSource | null) {}
}

export enum HighlightedItemSource {
  PANEL,
  MAP,
}
